export const isGiftAidEligible = (organization) => {
    return organization.hasConnectedSwiftaidAtUtc && organization.hmrcReferenceNumber;
};
